__webpack_require__.p = "/assets/exo/505/";